import React, { useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Stack,
  useToast,
} from "@chakra-ui/react";

import { appRequest } from "routes";
import { Form, Formik } from "formik";
import CustomInput from "components/common/customInput/CustomInput";
import { changePasswordValidation, changePasswordWithoutCurrentValidation } from "./validations/validation";


type ModalProps = {
  isOpen: boolean;
  isCurrentPass: boolean;
  id?: string;
  onClose: () => void;
};

type LoginFormValues = {
  password: string;
  newPassword: string;
  confirmPassword: string;
};
type LoginFormErrors = {
  password?: string;
  newPassword?: string;
  confirmPassword?: string;
};

export default function ResetPasswordFormModal({
  isOpen,
  onClose,
  isCurrentPass,
  id,
}: ModalProps): JSX.Element {
  const toast = useToast();
  const [showError, setShowError] = useState(false);

  // const [values, ] = useState<LoginFormValues>({
  //   password: "",
  //   newPassword: "",
  //   confirmPassword: "",
  // });
  // const [, setErrors] = useState<LoginFormErrors>({});

  // const validatePassword = () => {
  //   if (!values.password) {
  //     setErrors((prevErrors) => ({
  //       ...prevErrors,
  //       password: "Password is isRequired",
  //     }));
  //   } else if (values.password.length < 6) {
  //     setErrors((prevErrors) => ({
  //       ...prevErrors,
  //       password: "Password must be at least 6 characters long",
  //     }));
  //   } else {
  //     setErrors((prevErrors) => ({ ...prevErrors, password: undefined }));
  //   }
  // };

  // const validateNewPassword = () => {
  //   if (!values.newPassword) {
  //     setErrors((prevErrors) => ({
  //       ...prevErrors,
  //       newPassword: "New Password is isRequired",
  //     }));
  //   } else if (values.newPassword.length < 6) {
  //     setErrors((prevErrors) => ({
  //       ...prevErrors,
  //       newPassword: "New Password must be at least 6 characters long",
  //     }));
  //   } else {
  //     setErrors((prevErrors) => ({ ...prevErrors, newPassword: undefined }));
  //   }
  // };

  // const validateConfirmPassword = () => {
  //   if (!values.confirmPassword) {
  //     setErrors((prevErrors) => ({
  //       ...prevErrors,
  //       confirmPassword: "Confirm Password is isRequired",
  //     }));
  //   } else if (values.confirmPassword.length < 6) {
  //     setErrors((prevErrors) => ({
  //       ...prevErrors,
  //       confirmPassword: "Confirm Password must be at least 6 characters long",
  //     }));
  //   } else if (values.newPassword !== values.confirmPassword) {
  //     setErrors((prevErrors) => ({
  //       ...prevErrors,
  //       confirmPassword: "Passwords do not match",
  //     }));
  //   } else {
  //     setErrors((prevErrors) => ({
  //       ...prevErrors,
  //       confirmPassword: undefined,
  //     }));
  //   }
  // };

  // const handleSubmit = async (event: React.FormEvent<HTMLButtonElement>) => {
  //   event.preventDefault();
  //   validatePassword();
  //   validateNewPassword();
  //   validateConfirmPassword();

  //   if (
  //     !errors.password &&
  //     !errors.newPassword &&
  //     !errors.confirmPassword
  //   ) {
  //     let input;
  //     if (isCurrentPass) {
  //       input = {
  //         currentPassword: values.password,
  //         newPassword: values.newPassword,
  //         confirmPassword: values.confirmPassword,
  //       };
  //     } else {
  //       input = {
  //         newPassword: values.newPassword,
  //         confirmPassword: values.confirmPassword,
  //         id: id,
  //       };
  //     }
  //     try {
  //       setLoading(true);
  //       const response: any = await appRequest("user", "changePassword", input);
  //       if (response && !response.error) {
  //         toast({
  //           title: "Password Updated successfully.",
  //           status: "success",
  //           duration: 9000,
  //           isClosable: true,
  //           position: "top-right",
  //         });
  //         setValues({password: "",
  //         newPassword: "",
  //         confirmPassword: "",
  //       })
  //         onClose();
  //       } else {
  //         toast({
  //           title: response.error.message,
  //           status: "error",
  //           duration: 9000,
  //           isClosable: true,
  //           position: "top-right",
  //         });
  //       }
  //     } catch (error) {
  //       toast({
  //         title: "Account not created.",
  //         description: JSON.stringify(error),
  //         status: "error",
  //         duration: 9000,
  //         isClosable: true,
  //         position: "top-right",
  //       });
  //     } finally {
  //       setLoading(false);
  //     }
  //   }
  // };

  // const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   const { name, value } = event.target;
  //   setValues((prevValues) => ({ ...prevValues, [name]: value }));
  // };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <Formik
        initialValues={{
          currentPassword: "",
          newPassword: "",
          confirmPassword: "",
        }}
        onSubmit={async (values: any, { setSubmitting, resetForm }) => {
          try {
            console.log(values);
            const payload = isCurrentPass
              ? values
              : {
                  newPassword: values.newPassword,
                  confirmPassword: values.confirmPassword,
                  id,
                };
            const response: any = await appRequest(
              "user",
              "changePassword",
              payload
            );
            if (response && !response.error) {
              toast({
                title: "Password Updated successfully.",
                status: "success",
                duration: 9000,
                isClosable: true,
                position: "top-right",
              });
              resetForm();
              setShowError(false)
              onClose();
            } else {
              toast({
                title: response.error.message,
                status: "error",
                duration: 9000,
                isClosable: true,
                position: "top-right",
              });
            }
          } catch (error) {
            toast({
              title: "Account not created.",
              description: JSON.stringify(error),
              status: "error",
              duration: 9000,
              isClosable: true,
              position: "top-right",
            });
          } finally {
            setSubmitting(false);
          }
        }}
        validationSchema={
          isCurrentPass
            ? changePasswordValidation
            : changePasswordWithoutCurrentValidation
        }
      >
        {({ handleSubmit, handleChange, values, errors, isSubmitting } : any) => {
          console.log(errors);
          console.log(values);
          return (
            <Form onSubmit={handleSubmit}>
              <ModalContent>
                <ModalHeader
                  color="teal.300"
                  fontSize={{ base: "lg", md: "2xl" }}
                  fontWeight="700"
                >
                  Enter new password
                </ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                  <Stack spacing={4}>
                    {isCurrentPass && (
                      <CustomInput
                        label="Current Password"
                        type="password"
                        placeholder="Your current password"
                        name="currentPassword"
                        error={errors.currentPassword}
                        showError={showError}
                        value={values.currentPassword}
                        onChange={handleChange}
                        isRequired
                      />
                    )}
                    <CustomInput
                      label="New Password"
                      type="password"
                      placeholder="Your new password"
                      name="newPassword"
                      value={values.newPassword}
                      onChange={handleChange}
                      isRequired
                      error={errors.newPassword}
                      showError={showError}
                    />
                    <CustomInput
                      label="Confirm Password"
                      type="password"
                      placeholder="Re-enter your new password"
                      name="confirmPassword"
                      value={values.confirmPassword}
                      onChange={handleChange}
                      isRequired
                      error={errors.confirmPassword}
                      showError={showError}
                    />
                  </Stack>
                </ModalBody>
                <ModalFooter>
                  <Button colorScheme="red" w="80px" mr={6} onClick={onClose}>
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    bg="teal.300"
                    h={"45px"}
                    fontWeight="700"
                    color="white"
                    _hover={{
                      bg: "teal.400",
                    }}
                    onClick={() => setShowError(true)}
                    isLoading={isSubmitting}
                  >
                    Save
                  </Button>
                </ModalFooter>
              </ModalContent>
            </Form>
          );
        }}
      </Formik>
    </Modal>
  );
}
